module.exports = {
  "/": {
    "name": "root",
    "success": {
      "default": [
        "EMAIL_ADDRESSES_LOADED"
      ]
    },
    "error": [
      "EMAIL_ADDRESSES_ERROR"
    ]
  },
  "/global-preferences": {
    "name": "redirect-to-global-preferences"
  },
  "/global-integrations": {
    "name": "redirect-to-global-integrations"
  },
  "/basic": {
    "name": "basic",
    "success": {
      "default": [
        "UP_FRONT_REQUEST_LOADED",
        "LANGUAGE_EDITOR_DATA_LOADED",
        "MEETINGS_LINKS_LOADED"
      ]
    },
    "error": [
      "LANGUAGE_EDITOR_DATA_ERROR",
      "UP_FRONT_REQUEST_ERROR",
      "MEETINGS_LINKS_ERROR"
    ]
  },
  "/security": {
    "name": "security",
    "success": {
      "default": [
        "EMAIL_ADDRESSES_LOADED"
      ]
    },
    "error": [
      "EMAIL_ADDRESSES_ERROR"
    ]
  }
};